<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-BiDeng1`]" width="1em" height="1em" v-bind="$attrs"><rect x="3.125" y="14.747" width="1.67" height="8.552" rx=".835"/><rect x="13.407" y="14.136" width="1.67" height="4.594" rx=".835"/><rect x="3.96" y="18.73" width="1.67" height="11.117" rx=".835" transform="rotate(-90 3.96 18.73)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.46024 2.1594C9.56063 1.58506 10.0593 1.16599 10.6424 1.16602L17.965 1.16638C18.5531 1.16641 19.0546 1.59274 19.1493 2.17324L20.9726 13.3541C21.092 14.0863 20.5251 14.7503 19.7833 14.7473L8.69096 14.7013C7.94761 14.6982 7.38585 14.027 7.51385 13.2947L9.46024 2.1594ZM10.8574 2.81733H17.7171L18.9232 10.0244H9.57791L10.8574 2.81733ZM9.31161 11.5244L9.0317 13.101H19.4381L19.1743 11.5244H9.31161Z"/></svg>
</template>
<script>

export default {
  name: 'IconBiDeng1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
